import {remote} from '../constants/environment';
import {IC2PPaymentFeeConfirmation} from '../interfaces/dtos/c2p-payment-fee-confirmation.interface';
import {IStandardServiceResponse} from '../interfaces/services/standard-service.interface';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {defaultHeaders} from './headers';

export const postC2PPaymentFeeConfirmation = async (
  paymentFeeConfirmation: IC2PPaymentFeeConfirmation,
  token: string,
): Promise<IStandardServiceResponse> => {
  const remoteURI = remote.getC2PPaymentConfirmationPost();

  const handleResponse = async (response: Response) => {
    if (response.status === 200) {
      const data = await response.json();
      const {payload, success} = data;
      if (success && payload) {
        return {
          success: true,
          payload: null,
        };
      } else {
        return {
          success: false,
          payload: null,
        };
      }
    }
  };

  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'POST',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
        body: JSON.stringify({
          payload: paymentFeeConfirmation,
        }),
      });
    },
    handleResponse,
    remoteURI,
  )) as IStandardServiceResponse;
};
